import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Package } from 'lucide-react';
import { getFavorites, getFavoriteIds, removeFavorite } from '../lib/api';
import { useAuthStore } from '../lib/authStore';
import ProductCard from '../components/product/ProductCard';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';

export default function FavoritesPage() {
  const [products, setProducts] = useState([]);
  const [favoriteIds, setFavoriteIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isAuthenticated } = useAuthStore();

  useEffect(() => {
    const load = async () => {
      if (!isAuthenticated) { setLoading(false); return; }
      try {
        const [prodRes, idRes] = await Promise.all([getFavorites(), getFavoriteIds()]);
        setProducts(prodRes.data || []);
        setFavoriteIds(idRes.data || []);
      } catch (e) { console.error(e); }
      setLoading(false);
    };
    load();
  }, [isAuthenticated]);

  const toggleFav = async (id) => {
    setFavoriteIds(prev => prev.filter(f => f !== id));
    setProducts(prev => prev.filter(p => p.id !== id));
  };

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex flex-col bg-[#09090B]">
        <Header />
        <main className="flex-1 flex items-center justify-center py-16 pb-24 md:pb-16">
          <div className="text-center">
            <Heart className="h-20 w-20 text-zinc-700 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-white uppercase tracking-tight mb-3" style={{ fontFamily: 'Teko, sans-serif' }}>Favoritos</h2>
            <p className="text-zinc-500 mb-8">Faça login para ver seus produtos favoritos</p>
            <Link to="/login" data-testid="login-for-favorites" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-bold px-8 py-3 uppercase tracking-wider transition-all">
              Entrar
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-[#09090B]">
      <Header />
      <main className="flex-1 py-6 pb-24 md:pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl md:text-5xl font-bold text-white uppercase tracking-tight mb-2" style={{ fontFamily: 'Teko, sans-serif' }} data-testid="favorites-title">Favoritos</h1>
          <p className="text-zinc-500 text-sm mb-6">{products.length} produto{products.length !== 1 ? 's' : ''}</p>

          {loading ? (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">{[...Array(4)].map((_, i) => <div key={i} className="bg-zinc-900 border border-zinc-800 aspect-square animate-pulse" />)}</div>
          ) : products.length > 0 ? (
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="favorites-grid">
              {products.map((p) => <ProductCard key={p.id} product={p} isFavorite={true} onFavoriteToggle={toggleFav} />)}
            </div>
          ) : (
            <div className="text-center py-16">
              <Heart className="h-16 w-16 text-zinc-700 mx-auto mb-4" />
              <p className="text-zinc-500 text-lg mb-4">Nenhum favorito ainda</p>
              <Link to="/produtos" className="text-red-500 hover:text-red-400 font-bold uppercase text-sm tracking-wider">Explorar Produtos</Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
